import type { RouteRecordRaw } from "vue-router";

export const profileRoutes: RouteRecordRaw[] = [
  {
    path: "/profile",
    name: "profile",
    component: () => import(/* webpackChunkName: "dashboard-profile" */ "../../components/profile/ProfileView.vue"),
    meta: { titleKey: "pageTitle.profile", scrollGroup: "profile", viewGroup: "profile" }
  },
  {
    path: "/vehicles",
    name: "vehicles",
    component: () => import(/* webpackChunkName: "dashboard-vehicles" */ "../../components/vehicles/VehiclesView.vue"),
    meta: { titleKey: "pageTitle.vehicles", viewGroup: "vehicles" }
  },
  {
    path: "/vehicles/add/:plate?/:country?",
    name: "add-vehicle",
    component: () =>
      import(/* webpackChunkName: "dashboard-vehicles" */ "../../components/vehicles/AddVehicleView.vue"),
    props: true,
    meta: { titleKey: "pageTitle.addVehicle", viewGroup: "add-vehicle", viewGroupParams: ["plate", "country"] }
  },
  {
    path: "/vehicles/:id",
    name: "edit-vehicle",
    component: () =>
      import(/* webpackChunkName: "dashboard-vehicles" */ "../../components/vehicles/EditVehicleView.vue"),
    props: true,
    meta: { titleKey: "pageTitle.editVehicle", viewGroup: "edit-vehicle", viewGroupParams: ["id"] }
  },
  {
    path: "/payment-sources",
    name: "payment-sources",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-payment-sources" */ "../../components/payment-sources/PaymentSourcesView.vue"
      ),
    meta: { titleKey: "pageTitle.paymentSources", viewGroup: "payment-sources" }
  },
  {
    path: "/payment-sources/add",
    name: "add-payment-source",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-payment-sources" */ "../../components/payment-sources/AddPaymentSourceView.vue"
      ),
    meta: { titleKey: "pageTitle.addPaymentSource", viewGroup: "add-payment-source" }
  },
  {
    path: "/payment-sources/:id",
    name: "edit-payment-source",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-payment-sources" */ "../../components/payment-sources/EditPaymentSourceView.vue"
      ),
    props: true,
    meta: { titleKey: "pageTitle.editPaymentSource", viewGroup: "edit-payment-source", viewGroupParams: ["id"] }
  }
];
